import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderObject } from 'src/app/models/order-list.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { CartService } from 'src/app/services/cart/cart.service';

@Component({
  selector: 'ipm-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  @Input() orderDetails: OrderObject;
  @Input() renderType: string = "";
  @Input() type: string = "";
  @Input() currentSelectedOption: any = "";
  helpListData: Array<string> = [];
  currentSelectedData: string = "";
  textMessage: FormControl;
  beatList: Array<any> = [];
  beatIdList: Array<string> = [];
  soundIdList: Array<string> = [];
  errorMessage: string = ""
  @Output() supportSubmitSuccessFullyEvent: EventEmitter<any> = new EventEmitter();
  constructor(private activateRoute: ActivatedRoute,
    private commonService: CommonService,
    private orderService: CartService,
    public formService: FormsService,
    private router: Router,
    public browserService: BrowserStorageService) {


  }

  ngOnInit(): void {
    this.textMessage = this.formService.getFormControl('');
    this.prePareHelpData();
    if (this.orderDetails && this.orderDetails?.items?.length > 0) {
      this.beatList = this.orderDetails.items;
      this.beatList = this.beatList.filter((item: any) => {
        item['isSelected'] = false;
        return item;
      });
    }
  }

  /**
   * create Help Details List
   */
  prePareHelpData() {
    if (this.type === 'orderHelpSupport') {
      if (this.currentSelectedOption && this.currentSelectedOption?.key === "dispute_purchase")  { 
        this.helpListData = [
          "Duplicate orders",
          "Files are incorrect/mismatched",
          "Got a copyright claim",
          "My problem isn’t listed here"
        ]
      } else {
        this.helpListData = [
          "Unable to download media file",
          "Amount debited but order failed",
          "Payment keeps failing",
          "My problem isn’t listed here"
        ]
      }
    } else {
      this.helpListData = [
        "Unable to download invoice",
        "Amount not credited",
        "My problem isn’t listed here"
      ];
    }
  }


  downloadLiceFiles(fileUrl: string, type: string) {
    this.commonService.downloadFile(fileUrl, type);
  }

  
  onChangeRadio(event: any)  {
    this.currentSelectedData = event.value;
  }

  submitHelpRequest() {
    if (this.textMessage.value) {
      let sendMessage: any = {
        help_text: this.textMessage.value,
        requester_type: this.type === 'orderHelpSupport' ? 'buyer' : 'seller',
        category:  this.type === 'orderHelpSupport'  ? this.currentSelectedOption?.key :  "seller_support",
        issue: this.currentSelectedData
      }

      // For buyers: send order_id, For sellers: send sale_id
      if (this.type === 'orderHelpSupport') {
        sendMessage['order_id'] = this.orderDetails._id;
      } else {
        sendMessage['sale_id'] = this.orderDetails._id;
      }

      if (this.type === 'orderHelpSupport') {
        this.soundIdList = [];
        this.beatIdList = [];
        this.getSelectedBeatList();
        if (this.soundIdList.length === 0 && this.beatIdList.length === 0) {

        } else {
          if (this.soundIdList.length > 0) {
            sendMessage['sound_id'] = this.soundIdList;
          } 
          if (this.beatIdList.length > 0) {
            sendMessage['beat_id'] = this.beatIdList;
          }
        }
      }
``
      this.orderService.submitHelp(sendMessage).subscribe( res => {
        if (res?.data) {
          let ticketNumber = res?.data?.help_number;
          this.supportSubmitSuccessFullyEvent.emit(ticketNumber);
        }
      }, (error) => {
      this.commonService.showToastError(error);
      });
    } else {
      this.textMessage.markAsTouched();
    }
  }

  getSelectedBeatList() { 
      this.beatList.map((item: any) => {
        if (item.isSelected) {
           if (item.sound) {
            this.soundIdList.push(item?.sound?._id);
           } else {
            this.beatIdList.push(item?.beat?._id);
           }
        }
      });
  }

  closePopup() {
    this.commonService.closePopUp();
  }

  selectBeatItem(currentBeat: any) {

  }
    isFormValid(): boolean {
    // Must select an issue
    if (!this.currentSelectedData) return false;
    // Must enter a message
    if (!this.textMessage || !this.textMessage.value || this.textMessage.invalid) return false;
    // For orderHelpSupport, must select at least one item if beatList is present
    if (this.type === 'orderHelpSupport' && this.beatList && this.beatList.length > 0) {
      const anySelected = this.beatList.some((item: any) => item.isSelected);
      if (!anySelected) return false;
    }
    return true;
  }
}
